const encoder = new TextDecoder()

export const UInt8ToString = (value: Uint8Array): string =>
  encoder.decode(value)
